import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { SStorageService } from '../services/sessionStorage.service';

/** Prefijos de las rutas a las que se vuelve tras el login de Azure (lista blanca): aprobación TD, aprobación de aceptación de riesgo y calendario de eventos (enlace del correo). */
export const PREFIJOS_URL_TRAS_LOGIN = ['/app/mi-portal/aprobacion-td/', '/app/mi-portal/aprobacion-riesgo/', '/app/nodo/calendario-eventos'] as const;
/** Se conserva por compatibilidad: prefijo de la aprobación TD. */
export const PREFIJO_URL_TRAS_LOGIN = PREFIJOS_URL_TRAS_LOGIN[0];

/** true si la URL empieza EXACTAMENTE por uno de los prefijos permitidos. */
export function esUrlTrasLoginPermitida(url: string | null | undefined): boolean {
  return !!url && PREFIJOS_URL_TRAS_LOGIN.some((p) => url.startsWith(p));
}
export const CLAVE_URL_TRAS_LOGIN = 'urlTrasLogin';

@Injectable({
  providedIn: 'root'
})
export class TokenGuard implements CanActivate {
  constructor(private router: Router, private sstorageService: SStorageService) {}

  canActivate(_route?: ActivatedRouteSnapshot, state?: RouterStateSnapshot): boolean | UrlTree {
    const token = this.sstorageService.getItem('token');
    if (token && token.length > 0) {
      // Decodifica el JWT y verifica la expiración
      const payload = this.decodeJwtPayload(token);
      if (payload && payload.exp) {
        const expDate = this.expToDate(payload.exp);
        const now = new Date();
        // // console.log('Token expira en:', expDate.toLocaleString());
        // // console.log('Fecha actual:', now.toLocaleString());
        if (expDate > now) {
          return true;
        }
      }
    }
    // Enlace de aprobación del correo (TD o aceptación de riesgo): se recuerda el destino y se pasa por el login de Azure.
    const urlDestino = state?.url ?? '';
    if (esUrlTrasLoginPermitida(urlDestino)) {
      try {
        sessionStorage.setItem(CLAVE_URL_TRAS_LOGIN, urlDestino);
      } catch {
        // sin sessionStorage solo se pierde la vuelta automática
      }
      return this.router.createUrlTree(['/login/azure-auth']);
    }
    // Redirige a /error-page con code=401 si no hay token o está expirado
    return this.router.createUrlTree(['/error-page'], { queryParams: { code: 401 } });
  }

  private decodeJwtPayload(token: string): any | null {
    try {
      const payloadBase64 = token.split('.')[1];
      const payloadJson = atob(payloadBase64.replace(/-/g, '+').replace(/_/g, '/'));
      return JSON.parse(decodeURIComponent(escape(payloadJson)));
    } catch (e) {
      return null;
    }
  }

  /**
   * Convierte el campo exp (segundos desde 1970) a un objeto Date
   */
  private expToDate(exp: number): Date {
    return new Date(exp * 1000);
  }
}